<template>
  <el-submenu
    :index="list.functionName"
    v-if="list.children && list.children.length !== 0"
  >
    <template slot="title">
      <i :class="list.menuStyle"></i>
      <span slot="title" :style="{marginLeft: list.level * sliderIndent +'px' }">{{ list.functionName }}</span>
    </template>
    <menu-tree :list="i" v-for="i in list.children" :key="i.id"></menu-tree>
  </el-submenu>
  <router-link :to="list.functionUrl || '#'" v-else>
    <!-- <i :class="list.menuStyle"></i> -->
    <el-menu-item :index="list.functionUrl"><span :style="{marginLeft: list.level * sliderIndent +'px' }">{{
      list.functionName
      }}</span></el-menu-item>
  </router-link>
</template>

<script>
import { sliderIndent } from "@/config"
export default {
  name: "menuTree",
  props: {
    list: Object,
    index: "",
  },
  data() {
    return {
      sliderIndent: sliderIndent
    };
  },
  computed: {},
  mounted() {
    // console.log(this.list)
  },
  methods: {},
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/jh/pages/home/components/silder/treeSlider/components/menuTree.vue